<section class="places" *ngIf="orderId">
  <strong>Где лежит заказ</strong>
  <button type="button" mat-button (click)="reload()" [disabled]="loading">Обновить</button>
  <p class="error" *ngIf="error" role="alert">{{ error }}</p>
  <button
    type="button"
    mat-stroked-button
    *ngIf="pendingScope"
    (click)="retry()"
    [disabled]="loading"
  >
    Повторить неподтверждённое действие
  </button>
  <ng-container *ngIf="state">
    <div class="place" *ngFor="let placement of state.placements">
      <strong>{{ placement.cell_code }}</strong
      ><span>{{ quantity(placement) }} шт. оприходовано</span>
      <button type="button" mat-button (click)="print(placement, 'LABEL')" [disabled]="loading">
        Бирка
      </button>
      <button type="button" mat-button (click)="print(placement, 'RECEIPT')" [disabled]="loading">
        Термолента
      </button>
      <button
        type="button"
        mat-button
        (click)="release(placement)"
        [disabled]="loading || quantity(placement) > 0"
      >
        Освободить пустую
      </button>
    </div>
    <p *ngIf="!state.placements?.length">Место ещё не назначено.</p>
    <div class="place" *ngFor="let reservation of state.legacy_reservations">
      <span
        >Собрано без адреса: товар №{{ reservation.product_id }} ·
        {{ reservation.quantity }} шт.</span
      >
      <button
        type="button"
        mat-button
        (click)="beginLegacyPlace(reservation)"
        [disabled]="loading || !!pendingScope"
      >
        Разместить по одной штуке
      </button>
    </div>
    <div *ngIf="legacyReservation">
      <p *ngIf="legacyScanQueue.length">Сканов в очереди: {{ legacyScanQueue.length }}</p>
      <p>
        {{
          legacyProductScanned
            ? 'Положите одну штуку в ячейку заказа и сканируйте ячейку'
            : 'Сканируйте товар №' + legacyReservation.product_id
        }}
      </p>
      <mat-form-field appearance="outline"
        ><mat-label>Штрихкод</mat-label
        ><input
          matInput
          [(ngModel)]="legacyBarcode"
          [ngModelOptions]="{ standalone: true }"
          (keyup.enter)="scanLegacy()"
      /></mat-form-field>
      <button
        type="button"
        mat-button
        (click)="scanLegacy()"
        [disabled]="loading || !!pendingScope"
      >
        Принять скан
      </button>
    </div>
    <small *ngIf="state.pending_receiving?.length"
      >Ожидают завершения приёмки: {{ state.pending_receiving.length }} операций.</small
    >
    <small *ngIf="state.handlings?.length"
      >Есть товар в руках приёмщика. Его нужно разместить или вернуть.</small
    >
    <div class="place" *ngFor="let content of returnableContents">
      <span>Товар №{{ content.product_id }} · {{ content.quantity }} шт. · {{ cellCode(content) }}</span>
      <button type="button" mat-button (click)="requestReturn(content)" [disabled]="loading || !!pendingScope">Вернуть на склад</button>
      <small>Оприходование сохраняется; затем подтвердите физический возврат.</small>
    </div>
    <div class="place" *ngFor="let content of returns">
      <span
        >Вернуть со сборки: товар №{{ content.product_id }} · {{ content.quantity }} шт. ·
        {{ cellCode(content) }}</span
      >
      <button
        type="button"
        mat-button
        (click)="beginReturn(content)"
        [disabled]="loading || !!pendingScope"
      >
        Изъять из ячейки заказа
      </button>
    </div>
    <div *ngIf="returnContent">
      <p>
        {{ !returnSourceCellId ? 'Сканируйте исходную ячейку ' + cellCode(returnContent) : !returnProductScanned ? 'Сканируйте товар №' + returnContent.product_id : 'Разместите товар в обычной ячейке хранения и сканируйте её адрес.' }}
      </p>
      <p *ngIf="returnScanQueue.length">Сканов в очереди: {{ returnScanQueue.length }}</p>
      <button type="button" mat-button (click)="returnQuantity = returnQuantity - 1" [disabled]="loading || !!returnSourceCellId || returnQuantity <= 1">−</button>
      <mat-form-field appearance="outline"
        ><mat-label>Количество возврата</mat-label>
        <input
          matInput
          type="number"
          readonly
          min="1"
          [max]="returnContent.quantity"
          [(ngModel)]="returnQuantity"
          [ngModelOptions]="{ standalone: true }"
      /></mat-form-field>
      <button type="button" mat-button (click)="returnQuantity = returnQuantity + 1" [disabled]="loading || !!returnSourceCellId || returnQuantity >= returnContent.quantity">+</button>
      <mat-form-field appearance="outline"
        ><mat-label>Штрихкод</mat-label>
        <input
          #returnScanInput
          matInput
          [(ngModel)]="returnBarcode"
          [ngModelOptions]="{ standalone: true }"
          (keydown.enter)="$event.preventDefault(); confirmReturn()"
      /></mat-form-field>
      <button
        type="button"
        mat-button
        (click)="confirmReturn()"
        [disabled]="
          loading ||
          !!pendingScope ||
          !returnBarcode.trim() ||
          returnQuantity <= 0 ||
          returnQuantity > returnContent.quantity
        "
      >
        Принять скан
      </button>
    </div>
    <button type="button" mat-stroked-button (click)="choosePlace()" [disabled]="loading">
      Добавить место
    </button>
    <a mat-button [routerLink]="['/warehouse/order-picking']" [queryParams]="{ orderId: orderId }"
      >Отбор со склада</a
    >
    <div *ngIf="choices.length">
      <mat-form-field appearance="outline"
        ><mat-label>Свободная ячейка</mat-label>
        <mat-select [(value)]="cellId">
          <mat-option *ngFor="let cell of choices" [value]="cell.id" [disabled]="!cell.can_assign">
            {{ cell.code }}{{ cell.reason ? ' · ' + cell.reason : '' }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button type="button" mat-button (click)="assign()" [disabled]="loading || !cellId">
        Назначить
      </button>
      <small>Назначение места не подтверждает физическое размещение товара.</small>
    </div>
  </ng-container>
</section>
